import React, { useRef, useState, useEffect } from 'react';
import { FlyoutDirection } from '@apply/components';
import './../../../scss/controls/_flyoutmenubutton.scss';

export enum FlyoutMenuTheme {
    White = 'white',
    Red = 'red',
    Blue = 'blue',
    DarkBlueActive = 'darkblue',
    Transparent = 'transparent',
    TransparentRed = 'transparent-red',
}

export enum FlyoutMenuButtonBorderRadius {
    Small = 'smallBorder',
    Medium = 'mediumBorder',
}

export const FlyoutMenuButton: React.FC<{
    id: string;
    theme: FlyoutMenuTheme;
    borderRadius: FlyoutMenuButtonBorderRadius;
    disabled?: boolean;
    buttonContent: any;
    handleClick?: React.MouseEventHandler;
    hint?: string;
    height?: any;
    width?: any;
    children: any;
    direction: FlyoutDirection;
}> = ({
    id,
    theme,
    handleClick,
    hint,
    height,
    width,
    disabled,
    children,
    borderRadius = FlyoutMenuButtonBorderRadius.Small,
    direction,
    buttonContent,
}) => {
    const [buttonClicked, set_buttonClicked] = useState(false);
    const buttonRef = useRef<HTMLDivElement>(null);
    const setStyle = {
        cursor: `${disabled ? 'arrow' : 'pointer'}`,
        height: height,
        width: width,
    };

    const onClick = (event: React.MouseEvent) => {
        if (!buttonClicked) {
            set_buttonClicked(true);
            if (handleClick) {
                handleClick(event);
            }
        } else {
            set_buttonClicked(false);
        }
    };

    // Detect outside click
    useEffect(() => {
        const handleOutsideClick = (event: MouseEvent) => {
            if (buttonRef.current && !buttonRef.current.contains(event.target as Node)) {
                set_buttonClicked(false);
            }
        };

        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);
    return (
        <>
            <details className='flyout'>
                <summary role='button'>
                    <div
                        ref={buttonRef}
                        id={id}
                        className={`flyout-button ${theme} ${disabled ? 'disabled' : ''} ${buttonClicked ? 'selected' : 'unselected'} ${borderRadius}`}
                        style={setStyle}
                        onClick={!disabled ? onClick : undefined}
                        title={hint}
                    >
                        {buttonContent}
                    </div>
                </summary>
                <div className={`flyout container ${theme} ${direction}`}>{children}</div>
            </details>
        </>
    );
};
